import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger } from '@/components/ui/select';

interface MaritalStatusSelectProps {
  value: string;
  onChange: (value: string) => void;
  error?: string;
}

export function MaritalStatusSelect({ value, onChange, error }: MaritalStatusSelectProps) {
  return (
    <div className="space-y-2">
      <Select value={value || "placeholder"} onValueChange={onChange}>
        <SelectTrigger>
          {value ? (
            value === 'single' ? 'أعزب' :
            value === 'married' ? 'متزوج' :
            value === 'widowed' ? 'أرمل' :
            ''
          ) : 'اختر الحالة الاجتماعية'}
        </SelectTrigger>
        <SelectContent dir="rtl">
          <SelectItem value="single">أعزب</SelectItem>
          <SelectItem value="married">متزوج</SelectItem>
          <SelectItem value="widowed">أرمل</SelectItem>
        </SelectContent>
      </Select>
      {error && <p className="text-sm text-red-500">{error}</p>}
    </div>
  );
}